import { z } from 'zod';

import { defineQuery } from '@nesso/common-contracts/define';
import { practiceIdSchema } from '@nesso/common-contracts/ids';
import { metadata } from '@nesso/common-contracts/schema-metadata';

import { customServiceCodeSchema, serviceSchema } from './service-catalog.models';

export const GET_SERVICE_CATALOG_TYPE = 'service-catalog/get';

export const serviceCatalogSchema = z.object({
    services: z.array(serviceSchema),
    customCodes: z.array(customServiceCodeSchema),
});

export type ServiceCatalogValue = z.infer<typeof serviceCatalogSchema>;

export const getServiceCatalog = defineQuery(
    GET_SERVICE_CATALOG_TYPE,
    z.object({
        practiceId: practiceIdSchema.meta(metadata.recordId),
    }),
    serviceCatalogSchema,
);
